module.exports = __webpack_public_path__ + "static/img/icon_project.c24fe2cc.png";